import { Link, useLocation } from 'react-router-dom';

const articles = [
  {
    slug: 'supaserver-vs-firebase',
    title: 'Supaserver vs Firebase',
  },
  {
    slug: 'supaserver-vs-supabase',
    title: 'Supaserver vs Supabase',
  },
  {
    slug: 'supaserver-vs-xano',
    title: 'Supaserver vs Xano',
  },
];

export default function BlogSidebar() {
  const location = useLocation();
  const currentSlug = location.pathname.split('/').pop();

  return (
    <aside className="hidden lg:block w-56 flex-shrink-0">
      <div className="sticky top-8">
        <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
          Articles
        </h3>
        <nav className="space-y-1">
          {articles.map((article) => {
            const isActive = currentSlug === article.slug;
            return (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}`}
                className={`block px-3 py-2 text-sm rounded-lg transition-colors ${
                  isActive
                    ? 'bg-orange-50 text-orange-600 font-medium'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                {article.title}
              </Link>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}
